/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Loadingtemplate3Inputs */

const en_coinvestments_editemail_loadingtemplate3 = /** @type {(inputs: Coinvestments_Editemail_Loadingtemplate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading template...`)
};

/**
* | output |
* | --- |
* | "Loading template..." |
*
* @param {Coinvestments_Editemail_Loadingtemplate3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_loadingtemplate3 = /** @type {((inputs?: Coinvestments_Editemail_Loadingtemplate3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Loadingtemplate3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_loadingtemplate3(inputs)
});
export { coinvestments_editemail_loadingtemplate3 as "coInvestments_editEmail_loadingTemplate" }